import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as sessionView from '../../reducks/sessions'
import { urlPath } from '../../selectors/router'
import { sessionMetadata } from '../../selectors/sessions'
import * as analyticsView from '../../reducks/analytics'

class CurrentUser extends Component {
  static propTypes = {
    candidateSlug: PropTypes.string.isRequired,
  }

  componentDidMount() {
    this.props.fetchSessionMetadata()
  }

  componentDidUpdate(prevProps) {
    // Re-fetch metadata if the URL has changed
    if (prevProps.pathname !== this.props.pathname) {
      this.props.fetchSessionMetadata()
    }
  }

  render() {
    const { children, ...props } = this.props
    return children({ ...props })
  }
}

const mapStateToProps = state => ({
  pathname: urlPath(state),
  metadata: sessionMetadata(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchSessionMetadata: () => dispatch(sessionView.fetchMetadata(ownProps.candidateSlug)),
  signOut: () => dispatch(sessionView.signOut()),
  trackVisibilityStatus: (action, source, currentState) =>
    dispatch(
      analyticsView.trackEvent('Candidate: visibility status', {
        action,
        source,
        currentState,
      }),
    ),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  trackVisibilityStatus: (action, source) =>
    dispatchProps.trackVisibilityStatus(action, source, stateProps.metadata.currentState === 'live' ? 'visible' : 'not visible'),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CurrentUser)
